import styled from '@emotion/styled';
import { Title } from '@/components/atoms/Title';
import { Text } from '@/components/atoms/Text';

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: ${({ theme }) => theme.spacing[4]};
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const PanelTitle = styled(Title)`
    color: ${({ theme }) => theme.color.black};
`;
